const NormalBulkShipment = () => {
    return (
      <div>
        <div className="flex flex-col justify-center items-center">
        <hr className="w-full lg:w-[50rem] md:w-[46rem]  mx-[auto] md:mx-[auto]"/>
        <div className="lg:flex md:flex sm:flex grid flex-1 justify-center items-start mx-auto lg:max-w-[50rem] md:max-w-[46rem] sm:max-w-[43rem] my-[5rem] gap-14">
          
            <div className="flex flex-col justify-center">
              <h1 className="font-bold lg:text-3xl text-2xl text-[#373737]">
                Normal Bulk Shipment <br/> Distribution Services
              </h1>
              <p className="text-sm text-md  lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem] mt-[1rem]">
              Bulk shipping refers to the shipping of large quantities of goods (in this case documents) that are loaded 
              onto a carrier and distributed without packaging, such as a utility bill. TCS Printshop and Mailroom covers 
              all aspects of print and bulk distribution, fully capable of all customised requirements of a customer.
              </p>
              
                
            </div>
            <div className="flex-1 flex flex-col justify-center lg:mt-[0rem] mt-[1rem]">
              <img src="/MMs/normalbulk.jpg" alt="" className="max-w-[100%] rounded-md"/>
            </div>
          </div>
            
        </div>
      </div>
    );
  };
  
  export default NormalBulkShipment;